/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ParticipantObservationsVM { 
    id?: number;
    participantId?: number;
    schoolId?: number;
    observationDate?: string;
    dataEntryDate?: string;
    disaggregate?: string | null;
    countValue?: number;
    dataSource?: string | null;
    notes?: string | null;
    participantType?: string | null;
    gender?: string | null;
    level?: string | null;
    schoolName?: string | null;
    activityName?: string | null;
}

